import React from 'react';
import {formatDateWithTime, textTruncateByLength} from 'utils/other';

const getNewsIcon = (filter) => {
    switch(filter) {
        case 'twitter':
            return <div style={{fontSize: '20px', color: '#1DA1F2', padding: '0 10px 0 0'}}>
                <i className="fab fa-twitter-square"/>
            </div>;
        case 'facebook':
            return <div style={{fontSize: '18px', color: '#4267B2', padding: '0 10px 0 0'}}>
                <i className="fab fa-facebook"/>
            </div>;
        case 'instagram':
            return <div style={{fontSize: '18px', color: '#E1306C', padding: '0 10px 0 0'}}>
                <i className="fab fa-instagram"/>
            </div>;
        case 'youtube':
            return <div style={{fontSize: '18px', color: '#FF0000', padding: '0 10px 0 0'}}>
                <i className="fab fa-youtube"/>
            </div>;
        case 'rss':
            return <div style={{fontSize: '18px', color: '#ee802f', padding: '0 10px 0 0'}}>
                <i className="fas fa-rss"/>
            </div>;
        case 'google_ozmosys':
            return <div style={{fontSize: '18px', color: '#314784', padding: '0 10px 0 0'}}>
                <i className="fa fa-globe"/>
            </div>;
        case 'web':
            return <div style={{fontSize: '18px', color: '#6E7179', padding: '0 10px 0 0'}}>
                <i className="fa fa-cog"/>
            </div>;
        default:
            return <div style={{fontSize: '18px', color: '#ee802f', padding: '0 10px 0 0'}}>
                <i className="fas fa-rss"/>
            </div>;
    }
};

const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const getInfluenceName = (sourceName) => {
    switch(sourceName) {
        case 'twitter':
            return 'Followers';
        case 'facebook':
            return 'people like this';
        case 'youtube':
            return 'subscribers';
        case 'instagram': 
            return 'Followers';
        case 'rss':
            return '';
        case 'google_ozmosys':
            return '';
        case 'web':
            return '';
        default:
            return 'Followers';
    }
};

const Article = ({article, blockType, source}) => {

    const handleSourceNameFromBlock = () => {
        if(blockType === 'rss' || blockType === 'web' || blockType === 'google_ozmosys') {
            return null;
        } else if(blockType === 'twitter' && !source.twitterPageId) {
            return (
                article.authorScreenName &&
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={article.author_link || article.author_url || article.authorUrl}
                    style={{textDecoration: 'underline', paddingLeft: '5px'}}
                >
                    {' ' + article.authorScreenName || article.source.sourceName}
                </a>
            );
        } else {
            return (
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={source.url || article.author_link || article.author_url}
                    style={{textDecoration: 'underline', paddingLeft: '5px'}}
                >
                    {' ' + (article.author_screen_name || source.sourceName)}
                </a>
            );
        }
    };

    const handleSourceName = () => {
        if(blockType === 'rss' ||
            blockType === 'web' ||
            blockType === 'google_ozmosys' ||
            article.resource === 'rss' ||
            article.resource === 'google_ozmosys'
        ) {
            return null;
        } else if(article.resource === 'facebook' ||
            (article.source && (
                article.source.type === 'facebook' ||
                article.resource === 'twitter' ||
                article.source.type === 'twitter'))
        ) {
            return (
                (article.author_screen_name || article.authorScreenName || article.domain) && (
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={article.author_link || article.author_url || article.authorUrl || article.domain}
                        style={{textDecoration: 'underline', paddingLeft: '5px'}}
                    >
                        {' ' + ((article.author_screen_name || article.authorScreenName) || article.source.sourceName || article.domain)}
                    </a>
                )
            );
        } else {
            return (
                (article.author_screen_name || article.authorScreenName) && (
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={article.author_link || article.author_url || article.authorUrl}
                        style={{textDecoration: 'underline', paddingLeft: '5px'}}
                    >
                        {' ' + ((article.author_screen_name || article.authorScreenName) || article.source.sourceName)}
                    </a>
                )
            );
        }
    };

    const handleInfluence = (article) => {
        if(!article) return null;
        if(blockType === 'youtube') {
            return (
                <span>&nbsp;{`(${numberWithCommas(source.influence)} ${getInfluenceName(blockType)})`}</span>
            );
        } else if(article.influence && article.source && article.source.type === 'youtube') {
            return (
                <span>&nbsp;{`(${numberWithCommas(article.influence)} ${getInfluenceName(article.source.type)})`}</span>
            );
        } else if(Number.isInteger(article.influence)) {
            return (
                <span>&nbsp;{`(${numberWithCommas(article.influence)} ${getInfluenceName(blockType ? blockType : (article.type || article.sourceType || article.source.type))})`}</span>
            );
        }
    };

    return (
        <div className="home-page-article">
            <div className="home-page-article__sentiment">
                {article.sentiment === 0 ?
                    <i className="far fa-meh" style={{color: '#ced2d8'}}/>
                    : article.sentiment === 1 ?
                        <i className="far fa-smile" style={{color: '#2eb85c'}}/>
                        : article.sentiment === -1 ?
                            <i className="far fa-frown" style={{color: '#e55353'}}/>
                            :
                            <i className="far fa-meh"/>
                }
            </div>
            <div className="home-page-article__content">
                <div className="home-page-article__title">
                    <a href={article.url} target="_blank" rel="noopener noreferrer">
                        {article.title && textTruncateByLength(article.title, 140)}
                    </a>
                </div>
                {article.abstract &&
                <div
                    className="home-page-article__abstract">{article.abstract && textTruncateByLength(article.abstract, 300)}</div>
                }
                <div className="home-page-article__footer">
                    {getNewsIcon(blockType ? blockType : (article.type ? article.type : article.sourceType ? article.sourceType : (article.source ? article.source.type : '')))}
                    <div>{article.domain + ' • ' + formatDateWithTime(article.published || article.publishedAt)}</div>
                    {blockType ?
                        handleSourceNameFromBlock()
                        :
                        handleSourceName()
                    }
                    {handleInfluence(article)}
                </div>
            </div>
            {/*<div className="home-page-article__link">*/}
            {/*    <a href={article.url} target="_blank" rel="noopener noreferrer">*/}
            {/*        <i className="fas fa-external-link-alt"/>*/}
            {/*    </a>*/}
            {/*</div>*/}
        </div>
    );
};

export default Article;
